import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import DeviceForm from 'Services/ServiceProviderManagement/Features/Device/Components/DeviceForm'
import { useSingleDevice } from 'Services/ServiceProviderManagement/Features/Device/Hooks'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SERVICE_PROVIDER_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function DeviceCreatePage() {
  const baseUrl = `${SERVICE_PROVIDER_MANAGEMENT_ROOT_URL}/devices`
  const previousLocation = usePreviousLocation(baseUrl)
  const { singleLoading, submitLoading } = useSingleDevice(undefined)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: SERVICE_PROVIDER_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Devices`,
      link: baseUrl
    },
    {
      title: t`Create new device`
    }
  ]

  const isLoading = singleLoading === 'pending'

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new device`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <DeviceForm successBaseUrl={previousLocation} submitLoading={submitLoading} />
      </WithLoader>
    </Box>
  )
}
